import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
  width: calc(100% - 20px);
  max-width: 600px;
  border-radius: 8px;
  overflow-y: auto;
  background-color: ${theme.white};
  padding: 0 10px;
`;

const Content = styled.div`
  padding-bottom: 50px;
  height: calc(100vh - 230px);
  overflow-y: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

const ButtonExpandRow = styled.div`
  display: flex;
  justify-content: end;
`;

const FooterBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`;

export { Container, Content, ButtonExpandRow, FooterBar };